// Simple English translations for the app
export const translations = {
  // Header
  search: 'Search products...',
  home: 'Home',
  categories: 'Categories',
  myOrders: 'My Orders',
  profile: 'Profile',
  login: 'Login',
  logout: 'Logout',
  register: 'Register',
  cart: 'Cart',
  
  // Products
  addToCart: 'Add to Cart',
  outOfStock: 'Out of Stock',
  viewDetails: 'View Details',
  allProducts: 'All Products',
  
  // Cart
  yourCart: 'Your Cart',
  emptyCart: 'Your cart is empty',
  continueShopping: 'Continue Shopping',
  checkout: 'Checkout',
  total: 'Total',
  remove: 'Remove',
  
  // Checkout
  deliveryAddress: 'Delivery Address',
  pincode: 'Pincode',
  phone: 'Phone',
  notes: 'Order Notes (Optional)',
  placeOrder: 'Place Order (COD)',
  orderPlaced: 'Order Placed Successfully!',
  
  // Orders
  orderHistory: 'Order History',
  orderDetails: 'Order Details',
  status: 'Status',
  items: 'Items',
  
  // Status
  pending: 'Pending',
  confirmed: 'Confirmed',
  processing: 'Processing',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  returned: 'Returned',
  
  // Auth
  email: 'Email',
  password: 'Password',
  name: 'Name',
  address: 'Address',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  
  // Home
  freshDelivery: 'Fresh Delivery',
  toYourDoor: 'to your doorstep',
  shopNow: 'Shop Now',
  shopByCategory: 'Shop by Category',
  featuredProducts: 'Featured Products',
  viewAll: 'View All',
  
  // Pincode
  deliverTo: 'Deliver to',
  change: 'Change',
  enterPincode: 'Enter pincode',
  checkDelivery: 'Check',
  deliveryAvailable: 'Delivery Available',
  deliveryNotAvailable: 'Delivery not available',
  
  // General
  loading: 'Loading...',
  error: 'Something went wrong',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  submit: 'Submit',
  
  // Admin
  dashboard: 'Dashboard',
  products: 'Products',
  orders: 'Orders',
  customers: 'Customers',
  banners: 'Banners',
  pincodes: 'Pincodes',
  returns: 'Returns',
  settings: 'Settings',
  totalRevenue: 'Total Revenue',
  totalOrders: 'Total Orders',
  totalProducts: 'Total Products',
  totalCustomers: 'Total Customers',
  recentOrders: 'Recent Orders',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  addCategory: 'Add Category',
  addBanner: 'Add Banner',
  addPincode: 'Add Pincode',
};

// Simple translation function - always returns English
export const t = (key) => {
  return translations[key] || key;
};

// Get product name (just return name, no Hindi)
export const getProductName = (product) => {
  return product.name;
};

// Get product description (just return description, no Hindi)
export const getProductDescription = (product) => {
  return product.description;
};

// Get category name (just return name, no Hindi)
export const getCategoryName = (category) => {
  return category.name;
};

// Get banner title (just return title, no Hindi)
export const getBannerTitle = (banner) => {
  return banner.title;
};

// Get area name (just return area_name, no Hindi)
export const getAreaName = (pincode) => {
  return pincode.area_name;
};
